import CheckCircleRoundedIcon from '@mui/icons-material/CheckCircleRounded';
import TimelineConnector from '@mui/lab/TimelineConnector';
import TimelineContent from '@mui/lab/TimelineContent';
import TimelineDot from '@mui/lab/TimelineDot';
import TimelineItem, { timelineItemClasses } from '@mui/lab/TimelineItem';
import TimelineSeparator from '@mui/lab/TimelineSeparator';
import {
  Box,
  Button,
  Container,
  Grid,
  Link,
  Paper,
  Stack,
  Typography,
} from '@mui/material';
import { useState } from 'react';

import EmploymentSubMenu from '@/components/nav/EmploymentSubMenu';
import ComingSoonPopup from '@/components/ui/ComingSoonPopup';
import ExitPopup945X from '@/components/ui/ExitPopup945X';
import Hidden from '@/components/ui/TzoHidden';
import AppLayout from '@/layouts/AppLayout';
import { Meta } from '@/layouts/Meta';

const Form945 = () => {
  const [open, setOpen] = useState(false);
  // const layoutWrapperContents: LayoutWrapperContents = {
  //   Heading: `Don't miss your payroll tax return deadline.`,
  //   SubHeading:
  //     'E-file Form 940 for easy compliance. File now and save time and stress.',
  //   CtaText: 'E-file Form 940 Now',
  //   CtaSubHeading: `Stay tax compliant with the IRS`,
  //   CtaURL: `${process.env.NEXT_PUBLIC_APPLICATION_URL}signup/?ref=sticky`,
  //   isActive: true,
  // };

  // const [lastDayTaxSeason, setLastDayTaxSeason] = useState(new Date());

  // useEffect(() => {
  //   setLastDayTaxSeason(getLastDateOfTheMonth(new Date().getFullYear(), 1, 31));
  //   setInterval(() => {
  //     setLastDayTaxSeason(getLastDateOfTheMonth(new Date().getFullYear(), 1, 31));
  //   }, 1000); // Updates every second (adjust if needed)
  // }, []);
  // // Random component
  // const Completionist = () => <span></span>;

  // // Renderer callback with condition
  // const renderer = ({
  //   days,
  //   hours,
  //   minutes,
  //   seconds,
  //   completed,
  // }: {
  //   days: number;
  //   hours: number;
  //   minutes: number;
  //   seconds: number;
  //   completed: boolean;
  // }) => {
  //   if (completed) {
  //     // Render a completed state
  //     return <Completionist />;
  //   }
  //   // Render a countdown
  //   return (
  //     <Stack
  //       direction={'row'}
  //       justifyContent={{ xs: 'center', md: 'flex-start' }}
  //       alignItems={'center'}
  //       spacing={1}
  //       sx={{
  //         '& .timer-count': {
  //           border: '1px solid #848484',
  //           p: 1.5,
  //           textAlign: 'center',
  //           minWidth: { xs: 55, sm: 70, md: 70 },
  //           position: 'relative',
  //           borderRadius: 2,
  //           boxShadow: ' 0 0 20px rgba(0,0,0,.12)',
  //         },
  //         '& .timer-number': {
  //           fontSize: { xs: 18, sm: 24 },
  //           fontWeight: 900,
  //         },
  //         '& .colon': {
  //           fontSize: { xs: 18, sm: 24 },
  //           px: { xs: 0.2, sm: 0.5 },
  //           py: 0,
  //           mt: { xs: '-8px !important', sm: '-14px !important' },
  //         },
  //         '& .timer-label': {
  //           background: '#000',
  //           borderTop: '1px solid #848484',
  //           fontSize: { xs: 10, sm: 12 },
  //           fontWeight: 500,
  //           mt: 0,
  //           mx: -1.5,
  //           mb: -1.5,
  //           py: 0.2,
  //           px: { xs: 0.5, sm: 1, lg: 0.5 },
  //           borderRadius: '0px 0px 8px 8px',
  //         },
  //       }}
  //     >
  //       <Box className="timer-count">
  //         <Box className="timer-number">
  //           {days?.toString().padStart(2, '0')}
  //         </Box>
  //         <Box className="timer-label">Day</Box>
  //       </Box>
  //       <Box className="colon">:</Box>
  //       <Box className="timer-count">
  //         <Box className="timer-number">
  //           {hours?.toString().padStart(2, '0')}
  //         </Box>
  //         <Box className="timer-label">Hours</Box>
  //       </Box>
  //       <Box className="colon">:</Box>
  //       <Box className="timer-count">
  //         <Box className="timer-number">
  //           {minutes?.toString().padStart(2, '0')}
  //         </Box>
  //         <Box className="timer-label">Minutes</Box>
  //       </Box>
  //       <Box className="colon">:</Box>
  //       <Box className="timer-count">
  //         <Box className="timer-number">
  //           {seconds?.toString().padStart(2, '0')}
  //         </Box>
  //         <Box className="timer-label">Seconds</Box>
  //       </Box>
  //     </Stack>
  //   );
  // };
  return (
    <AppLayout
      // LayoutWrapperContents={layoutWrapperContents}
      meta={
        <Meta
          title="E-file Form 945-X to correct your tax error | TaxZerone®"
          description="File Form 945-X to correct the overreporting and underreporting in previously filed Form 945. With TaxZerone Form filing made simple, secure and affordable."
          keywords=""
          canonical="employment-tax/e-file-irs-form-945-x/"
          jsonLdPricing="6.99"
          jsonLdAggregateRatingValue="5.00"
          jsonLdAggregateRatingCount="54869"
          ogShareImg="assets/images/employment-share-img.png"
        />
      }
    >
      <ExitPopup945X />
      <EmploymentSubMenu />
      <ComingSoonPopup open={open} setOpen={setOpen} />
      {/* <Container maxWidth="md">
        <Box sx={{ px: 2, mt: 3, mx: 0 }}>
          <Alert
            severity="warning"
            icon={<WarningIcon sx={{ fontSize: 30 }} />}
            sx={{ borderRadius: 3 }}
          >
            <AlertTitle
              sx={{ fontSize: { xs: 18, sm: 20, md: 22 }, fontWeight: 600 }}
            >
              Attention! Last Day to E-File Forms 940!
            </AlertTitle>

            <Typography
              variant="body1"
              sx={{ fontSize: { xs: 16, sm: 17, md: 18 } }}
            >
              Don&apos;t miss the deadline! Today is the <b>final day</b> to
              electronically file your <b>Form 940</b> (Annual Federal
              Unemployment Tax Return).
            </Typography>
          </Alert>
        </Box>
      </Container> */}
      {/* <Container
        sx={{
          position: 'relative',
          mt: 2,
          mb: 0,
        }}
        maxWidth="lg"
      >
        <Box
          sx={{
            background: 'linear-gradient(135deg, #0a7581, #0d2b2f)',
            p: 1.5,
            px: 2.5,
            color: '#fff',
          }}
          className="ribbon"
        >
          <Stack
            direction={{ xs: 'column', md: 'row' }}
            spacing={{ xs: 1, sm: 2 }}
            justifyContent="space-around"
            alignItems="center"
          >
            <Typography
              component={'div'}
              variant="body1"
              sx={{
                textAlign: { xs: 'center', sm: 'left' },
                fontSize: { xs: 15, sm: 17, md: 18, lg: '1.25rem' },
                color: '#fff',
                lineHeight: 1.3,
              }}
            >
              <strong>Act now!</strong> The IRS deadline has passed—
              <b style={{ color: '#fff' }}>E-File today</b> to minimize
              penalties and stay compliant.
            </Typography> */}
      {/* <Box>
              <Typography
                variant="body2"
                sx={{
                  textAlign: 'center',
                  mb: { xs: 1, sm: 1 },
                  lineHeight: 1.3,
                }}
              >
                Time Left Until the Deadline:
              </Typography>
              <Countdown date={lastDayTaxSeason} renderer={renderer} />
            </Box> */}
      {/* <Box> */}
      {/* <Button
                variant="contained"
                size="small"
                href={`${process.env.NEXT_PUBLIC_APPLICATION_URL}signup/?ref=form945`}
                sx={{
                  backgroundColor: '#fff',
                  '&:hover, &:focus': {
                    backgroundColor: '#0a7581',
                    color: '#fff',
                  },
                  px: 2,
                  color: '#333',
                  mt: { xs: 0, md: 0 },
                  display: { xs: 'inline-block', sm: 'inline-block' },
                  mx: { xs: 'auto', sm: 1 },
                  borderRadius: 3,
                  boxShadow: 'none',
                  fontSize: { xs: 14, sm: 16, md: 18 },
                  textTransform: 'none',
                  whiteSpace: 'nowrap',
                }}
              >
                E-File Now!
              </Button>
            </Box>
          </Stack>
        </Box>
      </Container> */}
      <Container maxWidth="xl" component="section">
        <Stack
          direction={{ xs: 'column', md: 'row' }}
          spacing={3}
          sx={{ px: { xs: 2, md: 0 } }}
        >
          <Box
            sx={{
              textAlign: { xs: 'center', md: 'left' },
              alignItems: 'center',
              display: 'flex',
              width: '100%',
              maxWidth: { xs: 'inherit', lg: 770 },
              minWidth: { xs: 'inherit', md: 530 },
              pl: { xs: 0, md: 6, lg: 8, xl: 12 },
              justifyContent: 'center',
            }}
          >
            <Box
              component="div"
              sx={{ mt: { xs: 2, sm: 4, md: 5 }, mb: { xs: 2, sm: 4, md: 5 } }}
            >
              <Typography
                variant="h1"
                sx={{
                  fontSize: { lg: 40, md: 30, sm: 24, xs: 24 },
                  fontWeight: 600,
                  color: '#374151',
                  mb: 3,
                }}
              >
                E-File Your{' '}
                <span className="highlight-container">
                  <span className="highlight">Form 945-X</span>
                </span>{' '}
                for Tax Year 2025
              </Typography>
              <Typography
                variant="body1"
                sx={{
                  fontSize: { lg: 20, md: 18, sm: 16, xs: 16 },
                  fontWeight: 400,
                  mb: 2,
                }}
              >
                Amend Your Withheld Federal Income Tax from{' '}
                <Hidden smDown>
                  {' '}
                  <br />
                </Hidden>
                non-payroll payments reported on Form 945 easily.
              </Typography>
              <Typography
                variant="body1"
                sx={{
                  fontSize: { lg: 20, md: 18, sm: 16, xs: 16 },
                  fontWeight: 400,
                  mb: 2,
                }}
              >
                TaxZerone&apos;s secure e-filing platform ensures form
                submissions are accurate and comply with IRS.
              </Typography>

              <Stack
                direction={{ xs: 'column-reverse', md: 'row' }}
                spacing={{ xs: 1, md: 6 }}
                justifyContent={{
                  xs: 'center',
                  md: 'flex-start',
                }}
                alignItems="center"
                sx={{ mt: 4 }}
              >
                <Box
                  sx={{
                    textAlign: 'center',
                    mr: { xs: 0, md: 4 },
                    mb: { xs: 2, sm: 0 },
                  }}
                >
                  <Button
                    variant="contained"
                    className="btn-primary"
                    sx={{
                      transition: 'all 0.3s ease 0s',

                      '&:hover, &:focus, &:active': { transform: 'scale(1.1)' },
                    }}
                    href={`${process.env.NEXT_PUBLIC_APPLICATION_URL}signup/?ref=form945x`}
                  >
                    Start E-Filing Now
                  </Button>
                  {/* <Typography
                    variant="body2"
                    sx={{ mt: 1, fontSize: { xs: 11, sm: 14 } }}
                  >
                    Takes 3 steps and less than 5 minutes
                  </Typography> */}
                </Box>
                <Hidden mdDown>
                  <Box sx={{}}>
                    <picture>
                      <source
                        srcSet="/assets/images/irs-authorized.webp"
                        className="mw-100"
                        width={70}
                        height={69}
                      />
                      <source
                        srcSet="/assets/images/irs-authorized.png"
                        className="mw-100"
                        width={70}
                        height={69}
                      />
                      <img
                        src="/assets/images/irs-authorized.png"
                        loading="lazy"
                        alt="IRS-authorized e-file provider"
                        className="mw-100"
                        width={70}
                        height={69}
                      />
                    </picture>
                  </Box>
                </Hidden>
              </Stack>
              <Box
                sx={{
                  position: 'relative',
                  maxWidth: 580,
                  mx: { xs: 'auto', md: 0 },
                  mt: 5,
                }}
              >
                {/* <Box
                  sx={{
                    background: '#333',
                    p: 1,
                    px: 2,
                    color: '#fff',
                    '&.ribbon:before': { left: 0 },
                    '&.ribbon:after': { right: 0 },
                  }}
                  className="ribbon"
                >
                  <Box>
                    <Typography
                      variant="body1"
                      sx={{
                        textAlign: { xs: 'center', sm: 'center' },
                        fontSize: { xs: 16, sm: 18, md: 20 },
                      }}
                    >
                      Form 941 for Quarter 3, 2023, is due on{' '}
                      <strong>October 31</strong>
                    </Typography>
                  </Box>
                </Box> */}
              </Box>
            </Box>
          </Box>
          <Hidden mdDown>
            <Box
              sx={{
                display: 'flex',
                justifyContent: 'flex-end',
                alignItems: 'flex-end',
                width: '100%',
              }}
            >
              <picture style={{ marginBottom: -7 }}>
                <source
                  srcSet="/assets/images/945-x-landing-img.webp"
                  className="img-responsive-banner"
                  width={880}
                  height={725}
                />
                <source
                  srcSet="/assets/images/945-x-landing-img.png"
                  className="img-responsive-banner"
                  width={880}
                  height={725}
                />
                <img
                  src="/assets/images/945-x-landing-img.png"
                  alt="E-File Your Form 945-X for the 2025 Tax Year "
                  className="img-responsive-banner"
                  width={880}
                  height={725}
                />
              </picture>
            </Box>
          </Hidden>
          <Hidden mdUp smDown>
            <Box
              sx={{
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'flex-end',
                width: '100%',
                backgroundPosition: 'center center !important',
                mt: '0 !important',
              }}
            >
              <picture style={{ marginBottom: -7 }}>
                <source
                  srcSet="/assets/images/945-x-landing-img-sm.webp"
                  className="img-responsive-banner"
                  width={440}
                  height={365}
                />
                <source
                  srcSet="/assets/images/945-x-landing-img-sm.png"
                  className="img-responsive-banner"
                  width={440}
                  height={365}
                />
                <img
                  src="/assets/images/945-x-landing-img-sm.png"
                  alt="E-File Your Form 945-X for the 2025 Tax Year "
                  className="img-responsive-banner"
                  width={440}
                  height={365}
                />
              </picture>
            </Box>
          </Hidden>
        </Stack>
      </Container>

      <Grid
        container
        sx={{
          backgroundColor: '#f0f2f9',
          mx: '0 !important',
          width: '100% !important',
        }}
        spacing={2}
        m={0}
        component="section"
      >
        <Container
          maxWidth="lg"
          sx={{
            my: { xs: 0, md: 3, lg: 5 },
            py: { xs: 2, sm: 3, md: 3, lg: 3 },
            borderRadius: { xs: 0, md: 4 },
            mx: { xs: 0, md: 3, lg: 'auto' },
          }}
          className="gradient-bg"
        >
          <Stack
            direction={{ xs: 'column', sm: 'row' }}
            spacing={{ xs: 1, sm: 3 }}
            justifyContent="space-around"
            alignItems="center"
          >
            <Box sx={{ width: '100%' }}>
              <Typography
                variant="h2"
                sx={{
                  fontSize: { lg: 30, md: 28, sm: 26, xs: 22 },
                  fontWeight: 500,
                  mb: 0,
                  textAlign: 'left',
                  lineHeight: 1.5,
                }}
              >
                File Form 945-X online to IRS at most affordable price
              </Typography>
              <Typography
                variant="body1"
                sx={{
                  fontSize: { lg: 18, md: 18, sm: 16, xs: 16 },
                  fontWeight: 400,
                  color: '#f3f3f3',
                  mb: 0,
                  textAlign: 'left',
                }}
              >
                TaxZerone makes it simple to correct errors using our
                easy-to-use e-filing platform
              </Typography>
            </Box>
            <Box
              sx={{
                width: '100%',
                maxWidth: { xs: '100', sm: 250, md: 280 },
                textAlign: 'center',
                fontSize: 18,
                lineHeight: 1.2,
              }}
            >
              File Now at
              <br />
              <Box
                component="strong"
                sx={{
                  color: '#ffe400',
                  fontSize: { xs: 30, sm: 36, md: 48, lg: 60 },
                }}
              >
                $6.99
              </Box>
            </Box>
          </Stack>
        </Container>
      </Grid>
      <Grid
        container
        sx={{
          backgroundColor: '#fff',
          mx: '0 !important',
          width: '100% !important',
          py: 0,
        }}
        spacing={0}
        m={0}
        component="section"
      >
        <Container maxWidth="lg">
          <Grid
            container
            spacing={2}
            m={0}
            mt={7}
            mb={7}
            className="MuiGrid-root-width"
            sx={{ flexDirection: { xs: 'column-reverse', md: 'row' } }}
          >
            <Grid
              size={{ xs: 12, md: 5.5, lg: 5 }}
              sx={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                textAlign: {
                  lg: 'left',
                  md: 'left',
                  sm: 'center',
                  xs: 'center',
                },
              }}
            >
              <Box sx={{ mb: { xs: 3, md: 5 }, mt: { xs: -3, md: 5 } }}>
                <Typography
                  variant="h2"
                  sx={{
                    fontSize: { lg: 34, md: 30, sm: 26, xs: 22 },
                    fontWeight: 600,
                    mb: 3,
                  }}
                >
                  What is Form 945-X?
                </Typography>

                <Typography variant="body1">
                  <Link
                    href="/resources/employment-tax/form-945-x-instructions/"
                    sx={{ color: '#0202ff' }}
                  >
                    {' '}
                    Form 945-X
                  </Link>{' '}
                  is to correct the withheld income tax amount from payees
                  reported on previously filed{' '}
                  <Link
                    href="/resources/employment-tax/form-945-instructions/"
                    sx={{ color: '#0202ff' }}
                  >
                    Form 945
                  </Link>
                  , Annual Return of Withheld Federal Income Tax. The
                  overreported taxes are entitled for refund or tax credit and
                  the underreported taxes should be paid to the IRS.
                </Typography>
              </Box>
            </Grid>
            <Grid size={{ xs: 12, sm: 12, md: 6.5, lg: 7 }}>
              <Box
                component="div"
                sx={{
                  display: 'flex',
                  justifyContent: 'center',
                  alignItems: 'center',
                  height: '100%',
                  textAlign: { xs: 'center', md: 'right' },
                  my: { xs: 3, md: 0 },
                }}
              >
                <picture>
                  <source srcSet="/assets/images/945-x-img.webp" />
                  <source srcSet="/assets/images/945-x-img.png" />
                  <img
                    src="/assets/images/945-x-img.png"
                    alt="What is Form 945-X?"
                    className="img-responsive img-shadow"
                    loading="lazy"
                    width={440}
                    height={394}
                  />
                </picture>
              </Box>
            </Grid>
          </Grid>
        </Container>
      </Grid>

      <Grid
        container
        sx={{
          backgroundColor: '#f0f2f9',
          mx: '0 !important',
          width: '100% !important',
        }}
        spacing={2}
        m={0}
        component="section"
      >
        <Container maxWidth="lg" sx={{ mb: 5 }}>
          <Grid
            container
            direction="row"
            justifyContent="center"
            alignItems="center"
            spacing={2}
            m={2}
            mt={5}
            pb={0}
            className="MuiGrid-root-width"
          >
            <Grid size={12}>
              <Typography
                variant="h2"
                sx={{
                  fontSize: { lg: 34, md: 30, sm: 26, xs: 22 },
                  fontWeight: 600,
                  mb: 0,
                  textAlign: 'center',
                }}
              >
                Why file form 945-X?
              </Typography>
            </Grid>
          </Grid>
          <Grid
            container
            spacing={2}
            m={2}
            mt={2}
            py={{ xs: 0, sm: 4, md: 7 }}
            className="MuiGrid-root-width"
            justifyContent="center"
          >
            <Grid size={{ xs: 12, sm: 6, md: 4 }}>
              <Paper
                variant="outlined"
                sx={{
                  px: 3,
                  pt: 5,
                  pb: 5,
                  textAlign: 'center',
                  borderWidth: 3,
                  borderColor: '#626262',
                  borderRadius: 10,
                  minHeight: '100%',
                  backgroundColor: '#fff',
                }}
              >
                <Box
                  sx={{
                    backgroundColor: '#efefef',
                    borderRadius: '50%',
                    width: 90,
                    height: 90,
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    mx: 'auto',
                  }}
                >
                  <picture style={{ width: 60, height: 60 }}>
                    <source
                      srcSet="/assets/images/error-icon.webp"
                      width={60}
                      height={60}
                    />
                    <source
                      srcSet="/assets/images/error-icon.png"
                      width={60}
                      height={60}
                    />
                    <img
                      src="/assets/images/error-icon.png"
                      alt="Correct the errors"
                      loading="lazy"
                      width={60}
                      height={60}
                    />
                  </picture>
                </Box>
                <Typography
                  variant="h3"
                  sx={{
                    fontSize: { lg: 20, md: 18, sm: 18, xs: 18 },
                    fontWeight: 600,
                    my: 3,
                  }}
                >
                  Correct the errors
                </Typography>
                <Typography variant="body1">
                  The error in the previously filed 945 forms should be
                  corrected using <br /> Form 945-X
                </Typography>
              </Paper>
            </Grid>
            <Grid size={{ xs: 12, sm: 6, md: 4 }}>
              <Paper
                variant="outlined"
                sx={{
                  px: 3,
                  pt: 5,
                  pb: 5,
                  textAlign: 'center',
                  borderWidth: 3,
                  borderColor: '#626262',
                  borderRadius: 10,
                  minHeight: '100%',
                  backgroundColor: '#fff',
                }}
              >
                <Box
                  sx={{
                    backgroundColor: '#efefef',
                    borderRadius: '50%',
                    width: 90,
                    height: 90,
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    mx: 'auto',
                  }}
                >
                  <picture style={{ width: 60, height: 60 }}>
                    <source
                      srcSet="/assets/images/claim-icon.webp"
                      width={60}
                      height={60}
                    />
                    <source
                      srcSet="/assets/images/claim-icon.png"
                      width={60}
                      height={60}
                    />
                    <img
                      src="/assets/images/claim-icon.png"
                      alt="Claim overreported tax"
                      loading="lazy"
                      width={60}
                      height={60}
                    />
                  </picture>
                </Box>
                <Typography
                  variant="h3"
                  sx={{
                    fontSize: { lg: 20, md: 18, sm: 18, xs: 18 },
                    fontWeight: 600,
                    my: 3,
                  }}
                >
                  Claim overreported tax
                </Typography>
                <Typography variant="body1">
                  Adjust the overreported tax amount and claim as credits or
                  refund.
                </Typography>
              </Paper>
            </Grid>
            <Grid size={{ xs: 12, sm: 6, md: 4 }}>
              <Paper
                variant="outlined"
                sx={{
                  px: 3,
                  pt: 5,
                  pb: 5,
                  textAlign: 'center',
                  borderWidth: 3,
                  borderColor: '#626262',
                  borderRadius: 10,
                  minHeight: '100%',
                  backgroundColor: '#fff',
                }}
              >
                <Box
                  sx={{
                    backgroundColor: '#efefef',
                    borderRadius: '50%',
                    width: 90,
                    height: 90,
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    mx: 'auto',
                  }}
                >
                  <picture style={{ width: 60, height: 60 }}>
                    <source
                      srcSet="/assets/images/penalty-icon.webp"
                      width={60}
                      height={60}
                    />
                    <source
                      srcSet="/assets/images/penalty-icon.png"
                      width={60}
                      height={60}
                    />
                    <img
                      src="/assets/images/penalty-icon.png"
                      alt="Avoid Penalties"
                      loading="lazy"
                      width={60}
                      height={60}
                    />
                  </picture>
                </Box>
                <Typography
                  variant="h3"
                  sx={{
                    fontSize: { lg: 20, md: 18, sm: 18, xs: 18 },
                    fontWeight: 600,
                    my: 3,
                  }}
                >
                  Stay compliant with IRS
                </Typography>
                <Typography variant="body1">
                  Correct the administrative errors by filing form 945-X to stay
                  compliant with IRS.
                </Typography>
              </Paper>
            </Grid>
          </Grid>
        </Container>
      </Grid>
      <Grid
        container
        sx={{
          backgroundColor: '#fff',
          mx: '0 !important',
          width: '100% !important',
          backgroundPosition: 'center bottom',
          flexDirection: 'column',
        }}
        spacing={2}
        m={0}
        component="section"
      >
        <Container maxWidth="lg">
          <Grid
            container
            spacing={2}
            sx={{ mt: { xs: 2, sm: 6, md: 8 } }}
            className="MuiGrid-root-width"
          >
            <Grid size={12} textAlign="center">
              <Typography
                variant="h2"
                sx={{
                  fontSize: { lg: 34, md: 30, sm: 26, xs: 22 },
                  fontWeight: 600,
                  mb: 3,
                  textAlign: 'center',
                  lineHeight: 1.5,
                }}
              >
                File Your Form 945-X in just 3 steps
              </Typography>
              <Typography
                variant="body1"
                sx={{
                  fontSize: { lg: 18, md: 18, sm: 16, xs: 16 },
                  fontWeight: 400,
                  color: '#333333',
                  mb: 3,
                  textAlign: 'center',
                }}
              >
                Follow these steps to file Form 945-X easily and accurately
              </Typography>
            </Grid>
          </Grid>
        </Container>
        <Container maxWidth="xl" sx={{ mb: 5 }}>
          <Stack
            direction={{ xs: 'column', md: 'row' }}
            spacing={{ xs: 2, md: 5 }}
            sx={{ justifyContent: 'center', alignItems: 'center' }}
          >
            <Box
              component="div"
              sx={{
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                height: '100%',
                width: '100%',
                mt: { xs: -3, md: -5, lg: -8 },
              }}
            >
              <picture>
                <source
                  srcSet="/assets/images/945x-steps-img.webp"
                  className="img-responsive"
                  width={915}
                  height={790}
                />
                <source
                  srcSet="/assets/images/945x-steps-img.png"
                  className="img-responsive"
                  width={915}
                  height={790}
                />
                <img
                  src="/assets/images/945x-steps-img.png"
                  alt="File Form 945-X with the IRS in just 3 simple steps using TaxZerone"
                  className="img-responsive"
                  loading="lazy"
                  width={915}
                  height={790}
                />
              </picture>
            </Box>

            <Box
              sx={{
                width: '100%',
              }}
            >
              <Box
                component="ol"
                sx={{
                  [`& .${timelineItemClasses.root}:before`]: {
                    flex: 0,
                    padding: 0,
                  },
                  p: 2,
                  pl: 0,
                  ml: { xs: 0, sm: 0, md: -2 },
                }}
              >
                <TimelineItem>
                  <TimelineSeparator>
                    <TimelineDot
                      sx={{
                        backgroundColor: 'transparent',
                        boxShadow: 'none',
                        my: -1,
                        mb: -1.7,
                      }}
                    >
                      <picture>
                        <source
                          srcSet="/assets/images/step-1-icon.webp"
                          width={39}
                          height={39}
                        />
                        <source
                          srcSet="/assets/images/step-1-icon.png"
                          width={39}
                          height={39}
                        />
                        <img
                          src="/assets/images/step-1-icon.png"
                          alt="Step1: Enter the required details "
                          loading="lazy"
                          width={39}
                          height={39}
                        />
                      </picture>
                    </TimelineDot>
                    <TimelineConnector />
                  </TimelineSeparator>
                  <TimelineContent sx={{ mb: 2 }}>
                    <Typography
                      variant="h3"
                      sx={{
                        fontSize: { lg: 20, md: 18, sm: 18, xs: 18 },
                        fontWeight: 600,
                        mt: 0,
                        mb: 1,
                        color: '#36324a',
                      }}
                    >
                      Step1: Enter the required details
                    </Typography>
                    <Typography variant="body1">
                      Enter the Filer details and details of the correction
                      required in previously filed IRS form 945
                    </Typography>
                  </TimelineContent>
                </TimelineItem>
                <TimelineItem>
                  <TimelineSeparator>
                    <TimelineDot
                      sx={{
                        backgroundColor: 'transparent',
                        boxShadow: 'none',
                        m: 0,
                        mt: -1,
                        mb: -1.7,
                      }}
                    >
                      <picture>
                        <source srcSet="/assets/images/step-2-icon.webp" />
                        <source srcSet="/assets/images/step-2-icon.png" />
                        <img
                          src="/assets/images/step-2-icon.png"
                          alt="Step 2: Review the form 945-X"
                          loading="lazy"
                          width={39}
                          height={39}
                        />
                      </picture>
                    </TimelineDot>
                    <TimelineConnector />
                  </TimelineSeparator>
                  <TimelineContent sx={{ mb: 2 }}>
                    <Typography
                      variant="h3"
                      sx={{
                        fontSize: { lg: 20, md: 18, sm: 18, xs: 18 },
                        fontWeight: 600,
                        mt: 0,
                        mb: 1,
                        color: '#36324a',
                      }}
                    >
                      Step 2: Review the form 945-X
                    </Typography>
                    <Typography variant="body1">
                      Review the provided information carefully and ensure the
                      errors have been corrected
                    </Typography>
                  </TimelineContent>
                </TimelineItem>
                <TimelineItem>
                  <TimelineSeparator>
                    <TimelineDot
                      sx={{
                        backgroundColor: 'transparent',
                        boxShadow: 'none',
                        mt: -1,
                        mb: -1.7,
                      }}
                    >
                      <picture>
                        <source srcSet="/assets/images/step-3-icon.webp" />
                        <source srcSet="/assets/images/step-3-icon.png" />
                        <img
                          src="/assets/images/step-3-icon.png"
                          alt="Step 3: Submit it to IRS"
                          loading="lazy"
                          width={39}
                          height={39}
                        />
                      </picture>
                    </TimelineDot>
                  </TimelineSeparator>
                  <TimelineContent>
                    <Typography
                      variant="h3"
                      sx={{
                        fontSize: { lg: 20, md: 18, sm: 18, xs: 18 },
                        fontWeight: 600,
                        mt: 0,
                        mb: 1,
                        color: '#36324a',
                      }}
                    >
                      Step 3: Submit it to IRS
                    </Typography>
                    <Typography variant="body1">
                      Submit Form 945-X with our user-friendly platform
                    </Typography>
                  </TimelineContent>
                </TimelineItem>
              </Box>
              <Box sx={{ textAlign: { xs: 'center', md: 'left' } }}>
                <Button
                  variant="contained"
                  className="btn-primary"
                  sx={{
                    transition: 'all 0.3s ease 0s',

                    '&:hover, &:focus, &:active': { transform: 'scale(1.1)' },
                  }}
                  href={`${process.env.NEXT_PUBLIC_APPLICATION_URL}signup/?ref=form945x`}
                >
                  E-File Form 945-X Now
                </Button>
              </Box>
            </Box>
          </Stack>
        </Container>
      </Grid>
      <Grid
        container
        sx={{
          backgroundColor: '#f0f2f9',
          mx: '0 !important',
          width: '100% !important',
        }}
        spacing={2}
        m={0}
        className="dotted-curve"
        component="section"
      >
        <Container maxWidth="lg" sx={{ mb: 5 }}>
          <Grid
            container
            direction="row"
            justifyContent="center"
            alignItems="center"
            spacing={2}
            m={2}
            mt={5}
            pb={0}
            className="MuiGrid-root-width"
          >
            <Grid size={12}>
              <Typography
                variant="h2"
                sx={{
                  fontSize: { lg: 34, md: 30, sm: 26, xs: 22 },
                  fontWeight: 600,
                  mb: 3,
                  textAlign: 'center',
                }}
              >
                Choose TaxZerone for Filing Form 945-X
              </Typography>
              {/* <Typography
                variant="body1"
                sx={{
                  fontSize: { lg: 18, md: 18, sm: 16, xs: 16 },
                  fontWeight: 400,
                  color: '#333333',
                  mb: 3,
                  textAlign: 'center',
                }}
              >
                TaxZerone makes filing your Form 945 simple, secure, and
                efficient with these key features:
              </Typography> */}
            </Grid>
          </Grid>

          <Grid
            container
            spacing={2}
            m={2}
            mt={4}
            pb={{ xs: 0, sm: 4, md: 7 }}
            justifyContent="center"
          >
            <Grid size={{ xs: 12, sm: 6, md: 4 }}>
              <Paper
                variant="outlined"
                sx={{
                  p: 3,
                  py: 5,
                  textAlign: 'center',
                  borderWidth: 3,
                  borderColor: '#8492c0',
                  borderRadius: 10,
                  minHeight: '100%',
                }}
              >
                <Box
                  sx={{
                    backgroundColor: '#efefef',
                    borderRadius: '50%',
                    width: 90,
                    height: 90,
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    mx: 'auto',
                  }}
                >
                  <picture style={{ width: 60, height: 60 }}>
                    <source
                      srcSet="/assets/images/irs-icon.webp"
                      width={60}
                      height={60}
                    />
                    <source
                      srcSet="/assets/images/irs-icon.png"
                      width={60}
                      height={60}
                    />
                    <img
                      src="/assets/images/irs-icon.png"
                      alt=" IRS Authorized"
                      loading="lazy"
                      width={60}
                      height={60}
                    />
                  </picture>
                </Box>
                <Typography
                  variant="h3"
                  sx={{
                    fontSize: { lg: 20, md: 18, sm: 18, xs: 18 },
                    fontWeight: 600,
                    my: 3,
                  }}
                >
                  IRS Authorized
                </Typography>
                <Typography variant="body1">
                  TaxZerone is an IRS authorized E-file service provider,
                  ensuring Form 945-X are filed accurately and are complying
                  with IRS tax regulations.
                </Typography>
              </Paper>
            </Grid>
            <Grid size={{ xs: 12, sm: 6, md: 4 }}>
              <Paper
                variant="outlined"
                sx={{
                  p: 3,
                  py: 5,
                  textAlign: 'center',
                  borderWidth: 3,
                  minHeight: '100%',
                  borderColor: '#76ce97',
                  borderRadius: 10,
                  mt: { xs: 0, md: 4 },
                }}
              >
                <Box
                  sx={{
                    backgroundColor: '#efefef',
                    borderRadius: '50%',
                    width: 90,
                    height: 90,
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    mx: 'auto',
                  }}
                >
                  <picture style={{ width: 60, height: 60 }}>
                    <source
                      srcSet="/assets/images/easy-icon.webp"
                      width={60}
                      height={60}
                    />
                    <source
                      srcSet="/assets/images/easy-icon.png"
                      width={60}
                      height={60}
                    />
                    <img
                      src="/assets/images/easy-icon.png"
                      alt="Easy Filing"
                      loading="lazy"
                      width={60}
                      height={60}
                    />
                  </picture>
                </Box>
                <Typography
                  variant="h3"
                  sx={{
                    fontSize: { lg: 20, md: 18, sm: 18, xs: 18 },
                    fontWeight: 600,
                    my: 3,
                  }}
                >
                  Easy Filing
                </Typography>
                <Typography variant="body1">
                  TaxZerone made filing easier, simpler, Securer and faster. Our
                  platform helps to file Form 945-X in less than a minute.
                </Typography>
              </Paper>
            </Grid>
            <Grid size={{ xs: 12, sm: 6, md: 4 }}>
              <Paper
                variant="outlined"
                sx={{
                  p: 3,
                  py: 5,
                  textAlign: 'center',
                  borderWidth: 3,
                  borderColor: '#8492c0',
                  borderRadius: 10,
                  minHeight: '100%',
                }}
              >
                <Box
                  sx={{
                    backgroundColor: '#efefef',
                    borderRadius: '50%',
                    width: 90,
                    height: 90,
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    mx: 'auto',
                  }}
                >
                  <picture style={{ width: 60, height: 60 }}>
                    <source
                      srcSet="/assets/images/smart-icon.webp"
                      width={60}
                      height={60}
                    />
                    <source
                      srcSet="/assets/images/smart-icon.png"
                      width={60}
                      height={60}
                    />
                    <img
                      src="/assets/images/smart-icon.png"
                      alt="Smart Validations"
                      loading="lazy"
                      width={60}
                      height={60}
                    />
                  </picture>
                </Box>
                <Typography
                  variant="h3"
                  sx={{
                    fontSize: { lg: 20, md: 18, sm: 18, xs: 18 },
                    fontWeight: 600,
                    my: 3,
                  }}
                >
                  Smart Validations
                </Typography>
                <Typography variant="body1">
                  Our smart validation system detects the error in filing during
                  submission. It helps you to save the time and reduce the risk
                  of rejections.
                </Typography>
              </Paper>
            </Grid>
            <Hidden mdDown>
              <Grid size={12}>&nbsp;</Grid>
            </Hidden>
            <Grid size={{ xs: 12, sm: 6, md: 4 }}>
              <Paper
                variant="outlined"
                sx={{
                  p: 3,
                  py: 5,
                  textAlign: 'center',
                  borderWidth: 3,
                  minHeight: '100%',
                  borderColor: '#76ce97',
                  borderRadius: 10,
                  mt: { xs: 0, md: 4 },
                }}
              >
                <Box
                  sx={{
                    backgroundColor: '#efefef',
                    borderRadius: '50%',
                    width: 90,
                    height: 90,
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    mx: 'auto',
                  }}
                >
                  <picture style={{ width: 60, height: 60 }}>
                    <source
                      srcSet="/assets/images/lowest-icon.webp"
                      width={60}
                      height={60}
                    />
                    <source
                      srcSet="/assets/images/lowest-icon.png"
                      width={60}
                      height={60}
                    />
                    <img
                      src="/assets/images/lowest-icon.png"
                      alt="Affordable Price"
                      loading="lazy"
                      width={60}
                      height={60}
                    />
                  </picture>
                </Box>
                <Typography
                  variant="h3"
                  sx={{
                    fontSize: { lg: 20, md: 18, sm: 18, xs: 18 },
                    fontWeight: 600,
                    my: 3,
                  }}
                >
                  Affordable Price
                </Typography>
                <Typography variant="body1">
                  File your Form 945-X online to IRS at the most affordable
                  price in the industry without compromising the quality of
                  service.
                </Typography>
              </Paper>
            </Grid>
            <Grid size={{ xs: 12, sm: 6, md: 4 }}>
              <Paper
                variant="outlined"
                sx={{
                  p: 3,
                  py: 5,
                  textAlign: 'center',
                  borderWidth: 3,
                  borderColor: '#8492c0',
                  borderRadius: 10,
                  minHeight: '100%',
                }}
              >
                <Box
                  sx={{
                    backgroundColor: '#efefef',
                    borderRadius: '50%',
                    width: 90,
                    height: 90,
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    mx: 'auto',
                  }}
                >
                  <picture style={{ width: 60, height: 60 }}>
                    <source
                      srcSet="/assets/images/instant-icon.webp"
                      width={60}
                      height={60}
                    />
                    <source
                      srcSet="/assets/images/instant-icon.png"
                      width={60}
                      height={60}
                    />
                    <img
                      src="/assets/images/instant-icon.png"
                      alt="Instant Notifications"
                      loading="lazy"
                      width={60}
                      height={60}
                    />
                  </picture>
                </Box>
                <Typography
                  variant="h3"
                  sx={{
                    fontSize: { lg: 20, md: 18, sm: 18, xs: 18 },
                    fontWeight: 600,
                    my: 3,
                  }}
                >
                  Instant Notifications
                </Typography>
                <Typography variant="body1">
                  Get real-time updates about the filing status after
                  transmitting the return to the IRS.
                </Typography>
              </Paper>
            </Grid>
            <Grid size={{ xs: 12, sm: 6, md: 4 }}>
              <Paper
                variant="outlined"
                sx={{
                  p: 3,
                  py: 5,
                  textAlign: 'center',
                  borderWidth: 3,
                  minHeight: '100%',
                  borderColor: '#76ce97',
                  borderRadius: 10,
                  mt: { xs: 0, md: 4 },
                }}
              >
                <Box
                  sx={{
                    backgroundColor: '#efefef',
                    borderRadius: '50%',
                    width: 90,
                    height: 90,
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    mx: 'auto',
                  }}
                >
                  <picture style={{ width: 60, height: 60 }}>
                    <source
                      srcSet="/assets/images/support-icon.webp"
                      width={60}
                      height={60}
                    />
                    <source
                      srcSet="/assets/images/support-icon.png"
                      width={60}
                      height={60}
                    />
                    <img
                      src="/assets/images/support-icon.png"
                      alt="Friendly Support"
                      loading="lazy"
                      width={60}
                      height={60}
                    />
                  </picture>
                </Box>
                <Typography
                  variant="h3"
                  sx={{
                    fontSize: { lg: 20, md: 18, sm: 18, xs: 18 },
                    fontWeight: 600,
                    my: 3,
                  }}
                >
                  Friendly Support
                </Typography>
                <Typography variant="body1">
                  Our dedicated support team is there to assist with filing or
                  any other issues.
                </Typography>
              </Paper>
            </Grid>
          </Grid>
        </Container>
      </Grid>
      <Grid
        container
        sx={{
          backgroundColor: '#fff',
          mx: '0 !important',
          width: '100% !important',
          py: 0,
        }}
        spacing={0}
        m={0}
        component="section"
      >
        <Container maxWidth="lg">
          <Grid
            container
            spacing={3}
            m={0}
            mt={5}
            mb={8}
            className="MuiGrid-root-width"
            sx={{ flexDirection: { xs: 'column-reverse', md: 'row' } }}
          >
            <Grid
              size={{ xs: 12, sm: 12, md: 6.5, lg: 7 }}
              sx={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                textAlign: {
                  lg: 'left',
                  md: 'left',
                  sm: 'center',
                  xs: 'center',
                },
              }}
            >
              <Box sx={{ mb: { xs: 3, md: 5 }, mt: { xs: -3, md: 5 } }}>
                <Typography
                  variant="h2"
                  sx={{
                    fontSize: { lg: 34, md: 30, sm: 26, xs: 22 },
                    fontWeight: 600,
                    mb: 3,
                  }}
                >
                  What are the details required to{' '}
                  <Hidden mdDown>
                    {' '}
                    <br />
                  </Hidden>
                  file Form 945-X?
                </Typography>

                <Typography
                  component="div"
                  variant="body1"
                  sx={{ mb: 3, color: '#6e6e6e' }}
                >
                  <Box
                    component="ul"
                    sx={{
                      width: '100%',
                      listStyleType: 'none',
                      paddingLeft: 0,
                      textAlign: 'left',
                      ml: { xs: 0, sm: 3 },
                      mt: { xs: 0, md: 3 },
                      mb: { xs: 0, md: 3 },
                      '& li': { display: 'flex' },
                    }}
                  >
                    <li
                      style={{
                        marginBottom: 10,
                      }}
                    >
                      <CheckCircleRoundedIcon
                        sx={{ color: '#1da94a', mr: 1 }}
                      />{' '}
                      <Box>
                        <Typography
                          variant="h3"
                          sx={{
                            fontWeight: 600,
                            fontSize: { md: 20, sm: 18, xs: 16 },
                            mb: 0.6,
                          }}
                        >
                          {' '}
                          Employer Details :
                        </Typography>
                        <ul>
                          <li>- Business Name</li>
                          <li>- Employer Identification Number (EIN) </li>
                          <li>- Business Address </li>
                          <li>
                            - Calendar year of the return you are
                            correcting{' '}
                          </li>
                          <li>- Date when the error was discovered </li>
                        </ul>
                      </Box>
                    </li>
                    <li
                      style={{
                        marginBottom: 10,
                      }}
                    >
                      <CheckCircleRoundedIcon
                        sx={{ color: '#1da94a', mr: 1 }}
                      />{' '}
                      <Box>
                        <Typography
                          variant="h3"
                          sx={{
                            fontWeight: 600,
                            fontSize: { md: 20, sm: 18, xs: 16 },
                            mb: 0.6,
                          }}
                        >
                          Form 945-X information :
                        </Typography>
                        <ul>
                          <li>
                            - Total corrected federal income tax or back up
                            <Hidden mdDown>
                              {' '}
                              <br />
                            </Hidden>
                            withholding tax
                          </li>
                          <li>- Detailed explanation of your corrections </li>
                        </ul>
                      </Box>
                    </li>
                  </Box>
                </Typography>
              </Box>
            </Grid>
            <Grid size={{ xs: 12, md: 5.5, lg: 5 }}>
              <Box
                component="div"
                sx={{
                  display: 'flex',
                  justifyContent: 'center',
                  alignItems: 'center',
                  height: '100%',
                  textAlign: { xs: 'center', md: 'right' },
                  my: { xs: 3, md: 0 },
                }}
              >
                <picture>
                  <source srcSet="/assets/images/f945x-details-img.webp" />
                  <source srcSet="/assets/images/f945x-details-img.png" />
                  <img
                    src="/assets/images/f945x-details-img.png"
                    alt="What are the details required to file Form 945-X?"
                    className="img-responsive img-shadow"
                    loading="lazy"
                    width={550}
                    height={500}
                  />
                </picture>
              </Box>
            </Grid>
          </Grid>
        </Container>
      </Grid>

      <Box
        sx={{
          backgroundColor: '#1da94a',
          py: { lg: 8, md: 8, sm: 4, xs: 4 },
          mx: '0 !important',
          width: '100% !important',
          mb: 0,
          p: 2,
          textAlign: 'center',
        }}
        m={2}
        mt={0}
        className="curve-bg"
        component="section"
      >
        <Typography
          variant="h2"
          color="white"
          sx={{
            fontSize: { lg: 34, md: 30, sm: 26, xs: 22 },
            fontWeight: 600,
            mb: 3,
            lineHeight: 1.5,
          }}
        >
          Ready to correct the errors of form 945?
        </Typography>

        <Typography
          variant="body1"
          sx={{
            fontSize: { lg: 18, md: 18, sm: 16, xs: 16 },
            fontWeight: 400,
            color: '#f3f3f3',
            mb: 3,
            lineHeight: 1.5,
          }}
        >
          E-file Form 945-X with TaxZerone and enjoy all the benefits offered
        </Typography>
        <Box component="div" sx={{ margin: 'auto' }}>
          <Button
            variant="contained"
            sx={{
              mt: { xs: 0, sm: 4 },
              mb: { xs: 0, md: 0 },
              color: '#444',
              transition: 'all 0.3s ease 0s',
              '&:hover, &active': {
                backgroundColor: '#213e99 !important',
                color: '#fff',
                transform: 'scale(1.1)',
              },
            }}
            className="btn-secondary-white"
            href={`${process.env.NEXT_PUBLIC_APPLICATION_URL}signup/?ref=form945x`}
          >
            E-file Form 945-X Now
          </Button>
        </Box>
      </Box>
      <Container maxWidth="lg" component="section" aria-labelledby="f945x-faqs">
        <Grid
          container
          spacing={2}
          m={2}
          direction="row"
          justifyContent="center"
          className="MuiGrid-root-width"
          sx={{ my: { xs: 0, sm: 2 } }}
        >
          <Grid
            size={{ xs: 12, sm: 10, md: 9 }}
            textAlign="left"
            my={{ xs: 2, sm: 5 }}
            mb={3}
          >
            <Typography
              id="f945x-faqs"
              variant="h2"
              sx={{
                fontSize: { lg: 34, md: 30, sm: 26, xs: 22 },
                fontWeight: 600,
                mb: 5,
                textAlign: 'center',
              }}
            >
              Frequently Asked Questions
            </Typography>
            <Box
              component="div"
              sx={{ mb: 5 }}
              itemScope
              itemType="https://schema.org/FAQPage"
            >
              <Box
                itemScope
                itemProp="mainEntity"
                itemType="https://schema.org/Question"
                sx={{
                  border: '1px solid rgba(145, 158, 171, 0.35)',
                  p: 2,
                  mb: 2,
                  backgroundColor: '#fff',
                }}
              >
                <Typography
                  variant="h3"
                  sx={{
                    fontWeight: 600,
                    color: '#36324a',
                    fontSize: { lg: 20, md: 18, sm: 18, xs: 18 },
                  }}
                  itemProp="name"
                >
                  What is Form 945-X?
                </Typography>

                <Box
                  itemScope
                  itemProp="acceptedAnswer"
                  itemType="https://schema.org/Answer"
                >
                  <Typography component="p" itemProp="text" sx={{ mt: 1 }}>
                    <Link
                      href="/resources/employment-tax/form-945-x-instructions/"
                      sx={{ color: '#0202ff' }}
                    >
                      {' '}
                      Form 945-X
                    </Link>{' '}
                    is an IRS form used to correct the administrative error on
                    previously filed Form 945. You can correct the underreported
                    or/and overreported tax amount.
                  </Typography>
                </Box>
              </Box>
              <Box
                itemScope
                itemProp="mainEntity"
                itemType="https://schema.org/Question"
                sx={{
                  border: '1px solid rgba(145, 158, 171, 0.35)',
                  p: 2,
                  mb: 2,
                  backgroundColor: '#fff',
                }}
              >
                <Typography
                  variant="h3"
                  sx={{
                    fontWeight: 600,
                    color: '#36324a',
                    fontSize: { lg: 20, md: 18, sm: 18, xs: 18 },
                  }}
                  itemProp="name"
                >
                  What is Underreporting?
                </Typography>

                <Box
                  itemScope
                  itemProp="acceptedAnswer"
                  itemType="https://schema.org/Answer"
                >
                  <Box itemProp="text">
                    <Typography component="p" sx={{ mt: 1 }}>
                      When a filer reported less withheld federal income tax to
                      the IRS on their previously filed Form 945. Then the filer
                      underreported their tax and should file Form 945-X to
                      correct the underreported amount and pay the remaining
                      amount while filing.
                    </Typography>
                  </Box>
                </Box>
              </Box>
              <Box
                itemScope
                itemProp="mainEntity"
                itemType="https://schema.org/Question"
                sx={{
                  border: '1px solid rgba(145, 158, 171, 0.35)',
                  p: 2,
                  mb: 2,
                  backgroundColor: '#fff',
                }}
              >
                <Typography
                  variant="h3"
                  sx={{
                    fontWeight: 600,
                    color: '#36324a',
                    fontSize: { lg: 20, md: 18, sm: 18, xs: 18 },
                  }}
                  itemProp="name"
                >
                  What is Overreporting?
                </Typography>

                <Box
                  itemScope
                  itemProp="acceptedAnswer"
                  itemType="https://schema.org/Answer"
                >
                  <Box component="div" itemProp="text">
                    <Typography component="p" sx={{ mt: 1 }}>
                      If the filer reported more federal income tax withholding
                      to IRS than the actual amount on previously filed Form
                      945. Filer had overreported the withheld taxes and must
                      file Form 945-X to correct the overreported tax and the
                      amount will be returned as credits or refund.
                    </Typography>
                  </Box>
                </Box>
              </Box>
              <Box
                itemScope
                itemProp="mainEntity"
                itemType="https://schema.org/Question"
                sx={{
                  border: '1px solid rgba(145, 158, 171, 0.35)',
                  p: 2,
                  mb: 2,
                  backgroundColor: '#fff',
                }}
              >
                <Typography
                  variant="h3"
                  sx={{
                    fontWeight: 600,
                    color: '#36324a',
                    fontSize: { lg: 20, md: 18, sm: 18, xs: 18 },
                  }}
                  itemProp="name"
                >
                  Is electronic filing available for 945-X?
                </Typography>

                <Box
                  itemScope
                  itemProp="acceptedAnswer"
                  itemType="https://schema.org/Answer"
                >
                  <Typography component="p" itemProp="text" sx={{ mt: 1 }}>
                    Yes, you can file Form 945-X electronically with IRS.{' '}
                    <Link
                      href={`${process.env.NEXT_PUBLIC_APPLICATION_URL}signup/?ref=form945x`}
                      sx={{ color: '#0202ff' }}
                    >
                      TaxZerone
                    </Link>{' '}
                    makes e-filing simple, secure and affordable. Our platform
                    will reduce the risk of errors and transmit the form to IRS
                    faster.
                  </Typography>
                </Box>
              </Box>
            </Box>
          </Grid>
        </Grid>
      </Container>
    </AppLayout>
  );
};

export default Form945;
